import React, { useState } from 'react';
import { useSparks } from '../../contexts/SparksContext';
import AddyAvatar from './AddyAvatar';
import { useShop } from './useCosmeticCatalogue';
import { RATE_COPY, rememberTipClosed, tipDue } from './homeRates';

/** Addy's banner at the top of Home Learning explaining the colour-based Sparks. */
export default function HomeRatesTip({ childId }) {
  const { equipped } = useSparks();
  const shop = useShop(childId);
  const [open, setOpen] = useState(() => tipDue(childId));
  if (!open) return null;
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-[#F0EDFA] p-3 pr-2" data-testid="home-rates-tip">
      <div className="shrink-0"><AddyAvatar equipped={equipped} catalogue={shop?.items} size={64} /></div>
      <p className="flex-1 text-sm text-[#2E1F6B]">
        <strong className="block text-base text-[#5C3BD1]">{RATE_COPY.tipTitle}</strong>
        {RATE_COPY.tip}
      </p>
      <button
        type="button"
        aria-label="Close tip"
        onClick={() => { rememberTipClosed(childId); setOpen(false); }}
        className="self-start rounded-full px-2 text-xl leading-none text-[#5C3BD1] hover:bg-white/60"
      >
        ×
      </button>
    </div>
  );
}
